import { render, staticRenderFns } from "./AnnounceList.vue?vue&type=template&id=7c5faaff&scoped=true&"
import script from "./AnnounceList.vue?vue&type=script&lang=ts&"
export * from "./AnnounceList.vue?vue&type=script&lang=ts&"
import style0 from "./AnnounceList.vue?vue&type=style&index=0&id=7c5faaff&prod&scoped=true&lang=css&"
import style1 from "./AnnounceList.vue?vue&type=style&index=1&id=7c5faaff&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c5faaff",
  null
  
)

export default component.exports